import { Pipe, PipeTransform } from '@angular/core';
import { Frequency } from '@galaxy/billing';
import { frequencyForDisplay } from '../frequency';
/*
 * Formats the billing frequency to display
 *
 * Usage:
 *   {{ billingFrequency | frequency }}
 * Example:
 *   {{ BillingFrequency.Monthly | frequency }}
 *   formats to: 'Monthly'
 */
@Pipe({ standalone: true, name: 'frequency' })
export class FrequencyPipe implements PipeTransform {
  transform(frequency: Frequency): string {
    return `${frequencyForDisplay(frequency)}`;
  }
}
